<template>
	<div class="page">
		<Tip :tip="tip" />
		<div class="screen_div">
			<el-date-picker class="picker" v-model="screen.created_time" type="datetimerange"
				value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
				placeholder="请选择时间范围" />
            <el-select class="select" v-model="screen.created_by" clearable placeholder="人员列表" @visible-change='selectAdmin'>
				<el-option :key="0" label="全部" :value="0" />
				<el-option v-for="item in adminList" :key="item.admin_id" :label="item.nick_name" :value="item.admin_id" />
			</el-select>
			<el-select class="select" v-model="screen.commission_id" clearable placeholder="方案类型" @visible-change='selectCommission'>
                <el-option :key="0" label="全部" :value="0" />
				<el-option v-for="item in commissionList" :key="item.commission_id" :label="item.commission_name" :value="item.commission_id" />
			</el-select>
			<el-select class="select" v-model="screen.contract_id" clearable placeholder="合同列表" @visible-change='selectContract'>
                <el-option :key="0" label="全部" :value="0" />
				<el-option v-for="item in contractList" :key="item.procurement_id" :label="item.procurement_name" :value="item.procurement_id" />
			</el-select>
			<el-button class="screen_btn" @click="getCommissionList">筛选</el-button>
			<!-- <el-button class="screen_btn" type="primary">提成方案管理</el-button> -->
		</div>
		<div v-if="tableData.length != 0" class="row">
			<span>记录数：{{total}}</span>
			<span style="margin-left: 20px;">提成总额：{{total_commission_money}}</span>
		</div>
		<div class="from_div">
			<el-table class="table_div" :data="tableData" v-loading="loading" :header-cell-style="tabStyle">
				<el-table-column label="序号" props="log_id" width="80">
				</el-table-column>
				<el-table-column label="账号">
					<template slot-scope="scope">
						<span>{{scope.row.admin_name}} {{scope.row.admin_phone}}</span>
					</template>
				</el-table-column>
				<el-table-column label="合同业务">
					<template slot-scope="scope">
						<div class="col">
							<span>{{scope.row.consumer_name}}</span>
							<span>{{scope.row.contract_id}} {{scope.row.procurement_name}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="收款金额">
					<template slot-scope="scope">
						<span>{{scope.row.bill_amount}}</span>
					</template>
				</el-table-column>
				<el-table-column label="提成">
					<template slot-scope="scope">
						<span>{{scope.row.commission_money}}</span>
					</template>
				</el-table-column>
				<el-table-column label="提成方案">
					<template slot-scope="scope">
						<span>{{scope.row.commission_name}}</span>
					</template>
				</el-table-column>
				<el-table-column label="时间">
					<template slot-scope="scope">
						<span>{{scope.row.created_time}}</span>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!--弹出层-->
		<Popup :name="name" :show="show" @close='close' />
		<div class="foot_div">
			<!--分页按钮-->
			<el-pagination class="pagination" background layout="prev, pager, next,jumper, ->, total" :total="total"
				@current-change="handleCurrentChange" :currentPage="screen.page" :pageSize="screen.limit">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import Popup from "../../../components/Popup/Popup.vue"
	import {
		commission,
        adminLists,
        procurementLists
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip,
			Popup
		},
		data() {
			return {
				tip: '在财务收款时，触发业务提成的计算。',
				adminList: [], //角色列表
				commissionList: [], //提成方案列表
				contractList: [], //合同列表
				screen: {
					created_time: [], //创建时间范围
					admin_id: '', //人员id
					commission_id: '', //提成方案id
					contract_id: '', //合同id
					page: 1, //当前页 刷新后默认显示第一页
					limit: 10, //每一页显示的数据量 此处每页显示10条数据
				},
                loading: false,
				tableData: [],
				total: 0, //总条数
                total_commission_money: 0,
				name: '',
				show: false
			}
		},
		computed: {
			tabStyle() {
				return {
					background: '#f5f5f5',
					color: '#333'
				}
			}
		},
		mounted() {
			this.getCommissionList();
		},
		methods: {

			//获取提成明细列表
			getCommissionList() {
                this.loading = true;
				commission({
					...this.screen
				}, 5).then(res => {
                    this.loading = false;
					if (res.code == 0) {
						this.total = res.count;
						this.tableData = res.data;
                        this.total_commission_money = res.other.total_commission_money;
					} else {
						this.$message.error(res.msg);
					}
				}).catch(err => {})
			},

			//点击按钮切换页面
			handleCurrentChange(page) {
				this.screen.page = page; //每次点击分页按钮，当前页发生变化
				this.getCommissionList();
			},

            async selectAdmin(query){
                if (!query) {
                    return false;
                }
                const res = await adminLists()
                if (res.code) {
                    return this.$message.error(res.msg)
                }
                this.adminList = res.data;
            },

            async selectCommission(query){
                if (!query) {
                    return false;
                }
                const res = await commission({}, 4)
                if (res.code) {
                    return this.$message.error(res.msg)
                }
                this.commissionList = res.data;
            },

            async selectContract(query){
                if (!query) {
                    return false;
                }
                const res = await procurementLists({}, 3)
                if (res.code) {
                    return this.$message.error(res.msg)
                }
                this.contractList = res.data;
            },

			open(name) {
				this.name = name;
				this.show = true
			},
			close() {
				this.show = false
			}
		}
	}
</script>

<style scoped>
	.page {
		margin-bottom: 66px;
		padding: 20px 20px 0 20px;
		min-height: -webkit-fill-available;
	}

	.screen_div {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: auto;
		margin: 20px 0;
	}

	.col {
		display: flex;
		flex-direction: column;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.select {
		width: 128px;
		margin-left: 13px;
	}

    .picker {
		margin-left: 13px;
	}

	.screen_btn {
		margin-left: 13px;
	}

	.from_div {
		width: 100%;
		height: 580px;
		max-height: 100%;
		overflow: scroll;
		margin-top: 20px;
	}

	.table_div {
		width: 100%;
	}

	.foot_div {
		position: absolute;
		display: flex;
		flex-direction: row-reverse;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		margin-left: 66px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
		z-index: 9;
	}

	.pagination {
		display: flex;
		padding: 20px 30px 20px 30px
	}

	.el-dropdown-link {
		padding: 15px 5px;
		cursor: pointer;
		color: #fff;
	}

	.dropdown-menu {
		margin-bottom: 25px !important;
	}
</style>